import { createInterfaceId } from "@gitlab/needle";
//#region src/violations/sandbox_violations.ts
const SandboxViolations = createInterfaceId("SandboxViolations");
//#endregion
//#region src/violations/render.ts
const SANDBOX_BLOCK_MESSAGE = "Operation is blocked by sandbox.";
function renderSandboxViolation() {
	return SANDBOX_BLOCK_MESSAGE;
}
function renderViolation(violations, startMs, originalError, logger, command) {
	let recent;
	try {
		recent = command ? violations.getForCommandSince(command, startMs) : violations.getSince(startMs);
	} catch (err) {
		logger.debug(`Failed to query sandbox violations: ${err instanceof Error ? err.message : err}`);
		return;
	}
	if (recent.length === 0) return void 0;
	const sorted = [...recent].sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
	for (const violation of sorted) {
		const resource = lastToken(violation.description);
		if (resource && errorReferencesResource(originalError, resource)) {
			logger.debug(`Rewriting error as sandbox violation. Violation: "${violation.description}"; Original: "${originalError}"`);
			return SANDBOX_BLOCK_MESSAGE;
		}
	}
	logger.debug(`Sandbox violations in window but none referenced by error; skipping rewrite. Violations: ${sorted.map((v) => `"${v.description}"`).join(", ")}; Error: "${originalError}"`);
}
function lastToken(description) {
	const tokens = description.trim().split(/\s+/);
	return tokens[tokens.length - 1]?.replace(/\.+$/, "") || void 0;
}
function errorReferencesResource(error, resource) {
	const escaped = resource.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	return new RegExp(`${escaped}(?:[^/\\w]|$)`).test(error);
}
//#endregion
export { renderViolation as n, SandboxViolations as r, renderSandboxViolation as t };

//# sourceMappingURL=public-CCJiLaMq.mjs.map